import NoteItem from './note-item';

export default NoteItem;
